module.exports = __webpack_public_path__ + "img/check_icon_white.3b685ee3.svg";